/**
 * Constants for tool SDK
 */

/**
 * Query category keywords for intelligent search routing
 */
export const QUERY_CATEGORIES = {
  travel: [
    '旅游',
    'travel',
    'trip',
    '旅行',
    '攻略',
    'guide',
    '景点',
    'attraction',
    '酒店',
    'hotel',
  ],
  shopping: [
    '购物',
    'shopping',
    'buy',
    '买',
    '评测',
    'review',
    '种草',
    '测评',
  ],
  lifestyle: [
    '美食',
    'food',
    '餐厅',
    'restaurant',
    'cafe',
    '咖啡',
    '探店',
    '穿搭',
    'fashion',
  ],
  knowledge: [
    '如何',
    'how to',
    'how',
    '怎么',
    '教程',
    'tutorial',
    '学习',
    'learn',
  ],
  tech: [
    '编程',
    'programming',
    'code',
    '开发',
    'development',
    '技术',
    'tech',
    'api',
  ],
}

/**
 * Timeout configurations (in milliseconds)
 */
export const TIMEOUTS = {
  DEFAULT_REQUEST: 30000, // 30 seconds
  SHORT_REQUEST: 10000, // 10 seconds
  LONG_REQUEST: 60000, // 60 seconds
  PUPPETEER_NAVIGATION: 30000,
  PUPPETEER_WAIT_AFTER_LOAD: 1000,
  PUPPETEER_SELECTOR_WAIT: 10000,
}

/**
 * Content length limits (in characters)
 */
export const CONTENT_LIMITS = {
  DEFAULT_MAX_LENGTH: 10000, // 10K characters
  MAX_FETCH_CONTENT: 100000, // 100K characters
}
